import { Nav } from "reactstrap";
import Layout from "../../../custom/Layout";
import CustomNavItem from "../../../custom/CustomNavItem";
import { useState } from "react";
import { TabContent } from "reactstrap";
import CustomTabPane from "../../../custom/CustomTabPane";
import Trucks from "./Trucks";

export type TransfersManagementTab = 'TRUCKS';

export default function TransfersManagement () {

    const [activeTab, setActiveTab] = useState<TransfersManagementTab>('TRUCKS');

    const toggleTab = (tab: TransfersManagementTab) => setActiveTab(tab);

    return (
        <Layout>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<TransfersManagementTab>
                    tabName="Trucks"
                    tabId="TRUCKS"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<TransfersManagementTab> tabId={'TRUCKS'}>
                    <Trucks />
                </CustomTabPane>
            </TabContent>
        </Layout>
    );
}